import { render, staticRenderFns } from "./integralManagement.vue?vue&type=template&id=45743e12&scoped=true&"
import script from "./integralManagement.vue?vue&type=script&lang=ts&"
export * from "./integralManagement.vue?vue&type=script&lang=ts&"
import style0 from "./integralManagement.vue?vue&type=style&index=0&id=45743e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45743e12",
  null
  
)

export default component.exports